jQuery('.openModal').on('click', function() {
  var modalId = jQuery(this).data('modal');
  jQuery('#' + modalId).fadeIn();
});

jQuery('.close').on('click', function() {
  jQuery(this).closest('.modal').fadeOut();
});

jQuery(window).on('click', function(event) {
  jQuery('.modal').each(function() {
    if (jQuery(event.target).is(this)) {
      jQuery(this).fadeOut();
    }
  });
});
